exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; }\n\n.tag-button {\n  margin: 5px;\n  background: #f2f2f2;\n  border: 1px solid #e6e6e6;\n  border-radius: 5px;\n  padding: 10px;\n  cursor: pointer; }\n", ""]);

// exports
